import { FC } from 'react'
import { colors } from 'const/colors'
import { FAS_EXCLAMATION_CIRCLE } from 'const/icons'
import { clientInfo } from 'configureBrand'
import i18n from 'lang/i18n'
import Icon from 'ui/atoms/Icon'
import Body from 'syf-component-library/ui/typography/Body'
import { Stack } from 'syf-component-library/ui/spacing'
import { IEBannerWrapper, MessageBoxContainer, Title } from './subcomponents'

const IEBanner: FC = () => {
  const { clientName } = clientInfo

  const icon = (
    <Icon color={colors.error} name={FAS_EXCLAMATION_CIRCLE} size="26px" />
  )

  return (
    <IEBannerWrapper>
      <Stack />
      <MessageBoxContainer role="alert" type="error" icon={icon}>
        <Title weight="bold">{i18n({ IEBanner: 'IEBannertitle' })}</Title>
        <Stack />
        <Body>{i18n({ IEBanner: 'IEBannerContent' }, { clientName })}</Body>
      </MessageBoxContainer>
    </IEBannerWrapper>
  )
}

export default IEBanner
